@if (!statesService.progress) {
  <div class="box">
    <div class="row">
      @if (simulation.pet.type === 'dog') {
        @if (simulation.pet.droppedPee > 0) {
          <app-button (click)="cleaningPee()">
            💧 <br> Pipi <br> aufwischen
          </app-button>
        }
        @if (simulation.pet.droppedPoo > 0) {
          <app-button (click)="cleaningPoo()">
            🧹 <br> Häufchen <br> wegputzen
          </app-button>
        }
      }
      @if (simulation.pet.type === 'cat') {
        @if (simulation.pet.droppedPoo > 0 || simulation.pet.droppedPee > 0) {
          <app-button (click)="cleanToilet()"
            >
            🚽 <br> Katzenklo säubern
          </app-button>
        }
      }
      @if (simulation.pet.pollutionLvl > 50) {
        <app-button
          (click)="petCleaning()"
          >
          🛁 <br> Baden
        </app-button>
      }
      @if ((simulation.pet.illnessLvl >= 40 && simulation.pet.trustLvl >= 60) || simulation.pet.illnessLvl >= 75) {
        <app-button
          (click)="doctor()"
          >
          👩‍⚕️ <br> Zum Arzt <br> gehen
        </app-button>
      }
    </div>
    <div class="row">
      @if (!simulation.pet.sleeping) {
        @if (!statesService.states.showGames) {
          <app-button (click)="toggleFoods()"
            [class.activated]="statesService.states.showFoods"
            >
            @if (statesService.states.showFoods) {
              <span
                class="toggle"
                >
                <img src="assets/bilder/anderes/kreuz.webp" alt="kreuz">
              </span>
            }
            🍴 <br> Füttern
          </app-button>
        }
        @if (statesService.states.showFoods) {
          <div class="feeding row">
            <app-button (click)="water()">
              💧 <br> Wasser
            </app-button>
            @if (simulation.pet.type === 'dog') {
              @for (item of dogFoods; track item) {
                <div>
                  <app-button (click)="feeding(item)">
                    {{item.symbol}}
                    <br>
                      {{item.name}}
                    </app-button>
                  </div>
                }
              }
              @if (simulation.pet.type === 'cat') {
                @for (item of catFoods; track item) {
                  <div>
                    <app-button (click)="feeding(item)">
                      {{item.symbol}}
                      <br>
                        {{item.name}}
                      </app-button>
                    </div>
                  }
                }
              </div>
            }
            @if (!statesService.states.showFoods) {
              <app-button (click)="toggleGames()"
                [class.activated]="statesService.states.showGames"
                >
                @if (statesService.states.showGames) {
                  <span
                    class="toggle"
                    >
                    <img src="assets/bilder/anderes/kreuz.webp" alt="kreuz">
                  </span>
                }
                @if (simulation.pet.type === 'dog') {
                  <span>🐶</span>
                }
                @if (simulation.pet.type === 'cat') {
                  <span>🐱</span>
                }
                <br> Beschäftigen
                </app-button>
              }
              @if (statesService.states.showGames) {
                <div class="playing row">
                  @if (simulation.pet.type === 'dog') {
                    @for (item of dogGames; track item) {
                      <div>
                        @if (item.name !== 'Kuscheln') {
                          <app-button (click)="playing(item)"
                            >
                            {{item.symbol}}
                            <br>
                              {{item.name}}
                            </app-button>
                          }
                          @if (item.name === 'Kuscheln'
                            && simulation.pet.trustLvl >= 40) {
                            <app-button (click)="playing(item)"
                              >
                              {{item.symbol}}
                              <br>
                                {{item.name}}
                              </app-button>
                            }
                          </div>
                        }
                        <app-button (click)="walking()">
                          🐕 <br> Gassi gehen
                        </app-button>
                      }
                      @if (simulation.pet.type === 'cat') {
                        @for (item of catGames; track item) {
                          <div>
                            @if (item.name !== 'Streicheln') {
                              <app-button (click)="playing(item)"
                                >
                                {{item.symbol}}
                                <br>
                                  {{item.name}}
                                </app-button>
                              }
                              @if (item.name === 'Streicheln'
                                && simulation.pet.trustLvl >= 40) {
                                <app-button (click)="playing(item)"
                                  >
                                  {{item.symbol}}
                                  <br>
                                    {{item.name}}
                                  </app-button>
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                    <app-button
                      (click)="toggleSleeping()"
                      >
                      @if (!simulation.pet.sleeping) {
                        <span>
                          💤 <br> Schlafen legen
                        </span>
                      }
                      @if (simulation.pet.sleeping) {
                        <span>
                          ⏰ <br> Aufwecken
                        </span>
                      }
                    </app-button>
                  </div>
                </div>
              }
